// extracted by mini-css-extract-plugin
export default {"container":"lightSwitch_container__xr1-D","circle":"lightSwitch_circle__iRKLd","icon":"lightSwitch_icon__-hGzI","bar":"lightSwitch_bar__c6BZk"};